// src/components/GruposUsuario/GruposUsuario.js
import React, { useEffect, useState, useCallback, useContext } from "react";
import api, { BASE_URL } from "../../Utils/api";
import GruposUsuarioModal from "./GruposUsuarioModal";
import GridPadrao from "../GridPadrao/GridPadrao";
import PageHeader from "../PageHeader/PageHeader";
import { GlobalContext } from "../../Utils/GlobalContext";
import { useFeedback } from "../Generals/Feedback/FeedbackContext";


const GruposUsuario = () => {
  const { toast, confirm } = useFeedback();
  const { globalData } = useContext(GlobalContext);             // ✅ MOVIDO PARA DENTRO DO COMPONENTE
  const entidadeID = globalData?.entidade_id || localStorage.getItem("entidade_id");

  const [grupos, setGrupos] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedGrupo, setSelectedGrupo] = useState(null);

  const token = localStorage.getItem("authToken");
  const fetchGrupos = useCallback(async () => {
    if (!entidadeID) return;
    try {
      const { data } = await api.get(
        `${BASE_URL}/api/gruposusuario/ListarGruposUsuario/${entidadeID}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setGrupos(Array.isArray(data?.data) ? data.data : []);
    } catch (err) {
      console.error("Erro ao listar grupos de usuário", err);
      setGrupos([]);
    }
  }, [entidadeID, token]);

  useEffect(() => {
    fetchGrupos();
  }, [fetchGrupos]);

  const handleAdd = () => {
    setSelectedGrupo(null);
    setShowModal(true);
  };

  const handleEdit = (grupo) => {
    setSelectedGrupo(grupo);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedGrupo(null);
  };

  const handleExcluir = async (grupo) => {
    const ok = await confirm(`Tem certeza que deseja excluir o grupo "${grupo.descricao}"?`);
    if (ok) {
      try {
        await api.delete(
          `${BASE_URL}/api/gruposusuario/ExcluirGrupoUsuario/${grupo.id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("authToken")}`,
              id_entidade: entidadeID,
            },
          }
        );
        fetchGrupos();
      } catch (error) {
        console.error("Erro ao excluir grupo:", error);
        toast.error(error.response?.data?.message || "Erro ao excluir grupo. Tente novamente.");
      }
    }
  };

  const columns = [
    { Header: "Descrição", accessor: "descricao" },
    { Header: "Situação",  accessor: "situacao" },
  ];

  return (
    <div>
      <PageHeader titulo="Grupos de Usuário" path="/GrupoUsuario" />

      <GridPadrao
        columns={columns}
        data={grupos}
        onEdit={handleEdit}
        onAdd={handleAdd}
        addDataTour="grupos-usuario-adicionar"
        firstRowDataTour="grupos-usuario-primeira-linha"
        onInactivate={handleExcluir}
        rota="GrupoUsuario"
        habilitaVisaoColunas={false}
        defaultFilters={{ filters: { situacao: "a" }, dateFilters: {} }}
      />

      <GruposUsuarioModal
        show={showModal}
        handleClose={handleClose}
        grupo={selectedGrupo}
        fetchGrupos={fetchGrupos}
        entidadeId={entidadeID}
      />
    </div>
  );
};

export default GruposUsuario;
